import { fg } from '@atlaskit/platform-feature-flags/fg';
import { type CreationContextParams } from '@atlassian/conversation-assistant-external-context/types';

import { type MessageSource } from './types';

export type RemixRegenerateRequestAttributes = {
	isRemixRegenerate?: true;
	remixRegenerateSource?: 'inline-existing-node';
	editSource?: 'rovoBar' | 'typeSwitcher';
	contentMauiId?: string;
	mediaFileId?: string;
	remixSubtype?: string;
	remixType?: string;
};

export const getRemixRegenerateRequestAttributes = ({
	creationContextParams,
	messageSources,
}: {
	creationContextParams?: CreationContextParams;
	messageSources?: Partial<MessageSource>;
}): RemixRegenerateRequestAttributes => {
	if (fg('cc-maui-disable-edit-experience-tracker-fixes')) {
		return {};
	}

	const interactionSource = messageSources?.interactionSource;
	const isInlineExistingNodeEdit = interactionSource === 'inlineRovoFromRemix';
	const isExplicitRemixEditExperience =
		creationContextParams?.experience === 'remix_edit' ||
		creationContextParams?.experience === 'remix_custom';
	const isSharedEditInteractionSource =
		interactionSource === 'editor' || interactionSource === 'remixStagingArea';
	const isSharedEdit =
		creationContextParams?.source === 'remix' &&
		(isExplicitRemixEditExperience ||
			(isSharedEditInteractionSource &&
				Boolean(creationContextParams.contentMauiId || creationContextParams.mediaFileId)));

	if (!isInlineExistingNodeEdit && !isSharedEdit) {
		return {};
	}

	return {
		isRemixRegenerate: true,
		...(isInlineExistingNodeEdit ? { remixRegenerateSource: 'inline-existing-node' as const } : {}),
		editSource: interactionSource === 'editor' ? 'typeSwitcher' : 'rovoBar',
		contentMauiId: creationContextParams?.contentMauiId,
		mediaFileId: creationContextParams?.mediaFileId,
		remixType: creationContextParams?.dynamicUiType,
		remixSubtype: creationContextParams?.dynamicUiSubtype,
	};
};
